import * as React from "react";
import { connect } from "react-redux";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import { GetURIByParts } from "../../../services/Utils/StringUtils";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";
import { toast } from "react-toastify";
import {
  searchPaperReportsPaged,
  openReport,
  assignAndOpen,
  unAssign,
  getPaperReports
} from "./redux-objects/actions";
import {
  IDataQueueResponse,
  IExportColumnMap,
  PagedResultsRequest,
  SearchQueuePagedRequest
} from "../../../common/sharedTypes";
import { UserInfo, hasPermission } from "../../Login/common/defaults";
import * as documentDownloadService from "../../../services/documentDownloadService";
import ViewAllButton from "../../DocumentViewer/ViewAllButton";
import { Provider } from "react-redux";
import store from "../../../store/Store";
import rootReducer from "../../../store/Reducers";
import { QueueStartDate } from "../common";
const reduxStore = store({}, rootReducer);
import PagedDatatable from "../../PagedDataTable";
import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import LocalStorageUtils from "../common/LocalStorageUtils";
import MergedIndicator from "../common/MergedIndicator";
import CompletedIndicator from "../common/CompletedIndicator";
import DriverReportMergedIndicator from "../common/DriverReportMergedIndicator";

export interface IDataTranscribeQueueActionProps {
  searchPaperReportsPaged?: (
    url: string,
    request: SearchQueuePagedRequest
  ) => void;
  openReport?: (id: number) => Promise<void>;
  assignAndOpen?: (
    url: string,
    stepItemId: number,
    assignToId: number
  ) => Promise<void>;
  unAssign?: (url: string, stepItem: IDataQueueResponse) => Promise<void>;
}

interface IDataTranscribeQueueStateProps {
  workflowItemSteps: IDataQueueResponse[];
  webServiceURL: string;
  isProcessing: boolean;
  history: any;
  currentUser: UserInfo;
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
}

interface IDataTranscribeQueueProps
  extends IDataTranscribeQueueActionProps,
  IDataTranscribeQueueStateProps { }

enum ModalMode {
  None,
  New,
  Editing
}

enum ServiceEndPoints {
  SearchPaperReportDataQueue = "SearchTranscriberQueue",
  SearchTranscriberQueuePaged = "SearchTranscriberQueuePaged",
  AssignWorkflowItemStep = "AssignWorkflowItemStep",
  UnAssignWorkflowItemStep = "UnAssignWorkflowItemStep",
  GetPaperPdf = "GetPaperPdf"
}

const initialState = {
  userOnly: false,
  assignedOnly: false,
  unassignedOnly: false,
  startDate: moment(QueueStartDate),
  endDate: moment(),
  focusedInput: null,
  showModal: false,
  modalStatus: ModalMode.None,
  openingReport: false,
  includeNewDriverReports: false,
  pagingCriteria: {
    itemsPerPage: 10,
    pageNumber: 1,
    searchCriteria: null,
    orderByField: "PriorityNumber",
    orderDescending: false
  }
};
type DataTranscribeQueueState = Readonly<typeof initialState>;

class DataTranscribeQueue extends React.Component<
  IDataTranscribeQueueProps,
  DataTranscribeQueueState
> {
  public constructor(props: IDataTranscribeQueueProps) {
    super(props);
    this.state = initialState;
  }

  // TODO: Refactor to configuration file
  private workflowController: string = "Workflow";
  private includeNewDriverReportsVariable: string =
    "DataTranscriberIncludeNewDriverReportsCheckbox";
  private assignedOnlyVariable: string = "DataTranscriberAssignedOnlyCheckbox";
  private userOnlyVariable: string = "DataTranscriberUserOnlyCheckbox";
  private startDateVariable: string = "DataTranscriberStartDate";
  private endDateVariable: string = "DataTranscriberEndDate";
  private unassignedOnlyVariable: string = "DataTranscriberUnassignedOnlyCheckbox";

  componentDidMount() {
    const { workflowItemSteps } = this.props;
    this.populatePaperReports();

    if (workflowItemSteps.length === 0) {
    }
  }

  getLocalStorageItem(key) {
    try {
      let item: string = window.localStorage.getItem(key);
      let checkboxFlag = null;
      if (item == "true") checkboxFlag = true;
      if (item == "false") checkboxFlag = false;
      return checkboxFlag ? checkboxFlag : null;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  setLocalStorageItem(key, value) {
    window.localStorage.setItem(key, value);
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.log(error);
    }
  }

  closeModal = (e?) => {
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.None,
      showModal: false
    });
  };

  toggleScrollLock = () => {
    //document.querySelector('html').classList.toggle('scroll-lock');
  };

  handleAssignedOnlyCheck(isChecked) {
    LocalStorageUtils.setLocalStorageItem(this.assignedOnlyVariable, isChecked);
    this.setState({ assignedOnly: isChecked }, () => {
      this.populatePaperReports();
    });
  }

  handleUnassignedOnlyCheck(isChecked) {
    LocalStorageUtils.setLocalStorageItem(this.unassignedOnlyVariable, isChecked);
    this.setState({ unassignedOnly: isChecked }, () => {
      this.populatePaperReports();
    });
  }

  handleIncludeNewDriverReports(includeNew: any) {
    LocalStorageUtils.setLocalStorageItem(
      this.includeNewDriverReportsVariable,
      includeNew
    );
    this.setState(
      {
        includeNewDriverReports: includeNew
      },
      () => {
        this.populatePaperReports();
      }
    );
  }

  handleUserCheck(userChecked) {
    LocalStorageUtils.setLocalStorageItem(this.userOnlyVariable, userChecked);
    this.setState({ userOnly: userChecked }, () => {
      this.populatePaperReports();
    });
  }

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      LocalStorageUtils.setLocalStorageItem(this.startDateVariable, startDate);
      LocalStorageUtils.setLocalStorageItem(this.endDateVariable, endDate);
      this.setState({ startDate, endDate }, () => {
        this.populatePaperReports();
      });
    }
  }

  refreshPaperReports() {
    this.populatePaperReports();
  }

  populatePaperReports() {
    const uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.SearchTranscriberQueuePaged
    );
    const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
      this.userOnlyVariable
    );
    const persistentAssignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.assignedOnlyVariable
    );
    const persistentIncludeNewDriverReports =
      LocalStorageUtils.getLocalStorageBool(
        this.includeNewDriverReportsVariable
      );
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );
    const persistentUnassignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.unassignedOnlyVariable
    );

    const request: SearchQueuePagedRequest = {
      ...this.state.pagingCriteria,
      userOnly: persistentUserOnly ? persistentUserOnly : false,
      assignedOnly: persistentAssignedOnly ? persistentAssignedOnly : false,
      startDate: persistentStartDate
        ? persistentStartDate.toDate().toUTCString()
        : this.state.startDate.toDate().toUTCString(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate().toUTCString()
        : this.state.endDate.toDate().toUTCString(),
      queue: -3,
      includeNewDriverReports: persistentIncludeNewDriverReports
        ? persistentIncludeNewDriverReports
        : false,
      unassignedOnly: persistentUnassignedOnly ? persistentUnassignedOnly : false,
    };

    this.props.searchPaperReportsPaged(uri, request);
  }

  getExportData = async (): Promise<IDataQueueResponse[]> => {
    const uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.SearchTranscriberQueuePaged
    );
    const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
      this.userOnlyVariable
    );
    const persistentAssignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.assignedOnlyVariable
    );
    const persistentIncludeNewDriverReports =
      LocalStorageUtils.getLocalStorageBool(
        this.includeNewDriverReportsVariable
      );
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );
    const persistentUnassignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.unassignedOnlyVariable
    );

    const request: SearchQueuePagedRequest = {
      ...this.state.pagingCriteria,
      itemsPerPage: this.props.totalWorkflowItemSteps,
      pageNumber: 1,
      userOnly: persistentUserOnly ? persistentUserOnly : false,
      assignedOnly: persistentAssignedOnly ? persistentAssignedOnly : false,
      startDate: persistentStartDate
        ? persistentStartDate.toDate().toUTCString()
        : this.state.startDate.toDate().toUTCString(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate().toUTCString()
        : this.state.endDate.toDate().toUTCString(),
      queue: -3,
      includeNewDriverReports: persistentIncludeNewDriverReports
        ? persistentIncludeNewDriverReports
        : false,
      unassignedOnly: persistentUnassignedOnly ? persistentUnassignedOnly : false,
    };

    const response = await getPaperReports(uri, request);

    if (response.ok) {
      return response.data?.workflowItems || [];
    }
    return [];
  };

  handleOpenReport(rowData: IDataQueueResponse) {
    let reportId = rowData.reportId || 0;
    let docId = rowData.documentId;
    if (reportId == 0 && docId == null) {
      toast.error("Could not find report PDF");
      return;
    } else {
      documentDownloadService.openOnBaseImage(reportId, docId).then();
    }
  }

  handleAssignAndOpen(rowData: IDataQueueResponse) {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.AssignWorkflowItemStep
    );

    if (rowData.assignedTo == this.props.currentUser.username) {
      this.props.openReport(rowData.id).then(() => {
        this.props.history.push("/DataTranscriber");
      });
    } else {
      this.props.assignAndOpen(uri, rowData.id, null).then(() => {
        this.props.history.push("/DataTranscriber");
      });
    }
    // do stuff
  }

  handleUnAssign(rowData: IDataQueueResponse) {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.UnAssignWorkflowItemStep
    );
    this.props.unAssign(uri, rowData).then(() => {
      console.log("unassigned");
    });
  }

  handlePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ pagingCriteria: pagingCriteria as any }, () => {
      this.populatePaperReports();
    });
  };

  handleClearDateSelection = (): void => {
    LocalStorageUtils.removeLocalStorageItem(this.startDateVariable);
    LocalStorageUtils.removeLocalStorageItem(this.endDateVariable);
    this.setState(
      { startDate: moment(QueueStartDate), endDate: moment() },
      () => {
        this.populatePaperReports();
      }
    );
  };

  columns: TableColumn<IDataQueueResponse>[] = [
    {
      name: "AVAILABLE ACTIONS",
      selector: (row) => row?.id,
      sortField: "Id",
      sortable: true,
      wrap: true,
      format: (rowData: IDataQueueResponse) => {
        return (
          <div className="buttonColumn">
            <Provider store={reduxStore}>
              <ViewAllButton reportId={rowData.reportId} className="" />
            </Provider>
            {"  "}
            <Button
              variant="outline-primary"
              size="sm"
              onClick={(e) => this.handleOpenReport(rowData)}
            >
              {"   "}
              View
            </Button>{" "}
            {(!rowData.assignedTo ||
              rowData.assignedTo == this.props.currentUser.username) && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={(e) => this.handleAssignAndOpen(rowData)}
                >
                  {"   "}
                  {rowData.assignedTo == this.props.currentUser.username
                    ? "Continue"
                    : "Start"}
                </Button>
              )}
            {"   "}
            {rowData.assignedTo &&
              hasPermission(this.props.currentUser, "Reviewer") && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={(e) => this.handleUnAssign(rowData)}
                >
                  {"   "}
                  Unassign
                </Button>
              )}
          </div>
        );
      }
    },
    {
      name: "CRASH DATE",
      sortable: true,
      sortField: "CrashDate",
      wrap: true,
      selector: (row: IDataQueueResponse) =>
        row?.crashDate
          ? moment(row.crashDate).format("MM/DD/yyyy")
          : ""
    },
    {
      name: "WORKFLOW STATUS",
      sortField: "WorkflowStatus",
      wrap: true,
      selector: (row: IDataQueueResponse) =>
        row?.workflowStatus || "Status Indeterminable",
      sortable: true
    },
    {
      name: "ASSIGNED TO",
      sortField: "AssignedToUserName",
      wrap: true,
      selector: (row: IDataQueueResponse) =>
        (row?.assignedTo || "").split("@")[0],
      sortable: true
    },
    {
      name: "DOCUMENT ID",
      sortField: "DocumentId",
      wrap: true,
      selector: (row: IDataQueueResponse) => row?.documentId || "",
      sortable: true
    },
    {
      name: "COUNTY",
      sortField: "County",
      wrap: true,
      selector: (row: IDataQueueResponse) => row?.county || "",
      sortable: true
    },
    {
      name: "CRASH KEY",
      sortField: "OriginalCrashKey",
      wrap: true,
      selector: (row: IDataQueueResponse) => row?.originalCrashKey || "",

      format: (row: IDataQueueResponse) => (
        <div>
          {row?.originalCrashKey || ""}
          <MergedIndicator
            supplementedReports={row.supplementedReports}
            reportsMergedToThis={row.reportsMergedToThis}
            pendingMerge={row.pendingMerge}
          />          
          <CompletedIndicator
            completedDate={row.completedDate}
          />
          <DriverReportMergedIndicator
            hasMergedDriverReport={row.hasMergedDriverReport}
          />
        </div>
      ),
      sortable: true
    },
    {
      name: "PRIORITY",
      sortField: "PriorityNumber",
      wrap: true,
      selector: (row: IDataQueueResponse) => row?.priority || "",
      sortable: true
    }
  ];

  exportColumnMaps: IExportColumnMap[] = [
    { columnName: "ID", propertyName: "id" },
    {
      columnName: "DATE SUBMITTED",
      propertyName: "dateSubmitted",
      convertMethod: (val) => moment(val).format("MM/DD/YYYY hh:mma")
    },
    { columnName: "DOCUMENT ID", propertyName: "documentId" },
    { columnName: "ASSIGNED TO", propertyName: "assignedTo" },
    { columnName: "COUNTY", propertyName: "County" },
    { columnName: "WORKFLOW STATUS", propertyName: "workflowStatus" },
    { columnName: "PRIORITY", propertyName: "priority" }
  ];

  public render() {
    return (
      <div className="app">
        <div className="row">
          <div className="col-sm-6">
            <h3>Transcriber</h3>
          </div>
        </div>

        <hr />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="dataEntryQueueStartDate">
              <Form.Label>Date of Crash</Form.Label>
              <br />
              <DateRangePicker
                startDate={
                  LocalStorageUtils.getLocalStorageDate(
                    this.startDateVariable
                  ) || this.state.startDate
                } // momentPropTypes.momentObj or null,
                startDateId="dataEntryQueueStartDate" // PropTypes.string.isRequired,
                endDate={
                  LocalStorageUtils.getLocalStorageDate(this.endDateVariable) ||
                  this.state.endDate
                } // momentPropTypes.momentObj or null,
                endDateId="dataEntryQueueEndDate" // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
              {(LocalStorageUtils.getLocalStorageDate(this.startDateVariable) ||
                LocalStorageUtils.getLocalStorageDate(
                  this.endDateVariable
                )) && (
                  <button
                    className="btn btn-outline-danger btn-sm"
                    style={{ fontSize: "14px", marginLeft: "5px" }}
                    title="Clear Date Filter"
                    onClick={this.handleClearDateSelection}
                  >
                    <i className="fa fa-calendar-xmark" />
                  </button>
                )}
            </Form.Group>
            <Form.Group controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label=" Show only Assigned"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.assignedOnlyVariable
                )}
                onChange={(e) => this.handleAssignedOnlyCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="showOnUnassigned">
              <Form.Check
                type="checkbox"
                label=" Show only Unassigned"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.unassignedOnlyVariable
                )}
                onChange={(e) => this.handleUnassignedOnlyCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="AssignedMe">
              <Form.Check
                type="checkbox"
                label=" Show only Assigned to Me"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.userOnlyVariable
                )}
                onChange={(e) => this.handleUserCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="NewDriver">
              <Form.Check
                type="checkbox"
                label=" Held Driver Reports"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.includeNewDriverReportsVariable
                )}
                onChange={(e) =>
                  this.handleIncludeNewDriverReports(e.target.checked)
                }
              />
            </Form.Group>
          </Form.Row>
          <Form.Row />
        </Form>

        <PagedDatatable
          columns={this.columns}
          data={this.props.workflowItemSteps || []}
          loadingData={this.props.loadingWorkflowSteps}
          totalDataItems={this.props.totalWorkflowItemSteps}
          exportTitle="Data Transcriber Queue"
          exportFileName="DataTranscriberQueue"
          exportColumnMaps={this.exportColumnMaps}
          pagingCriteria={this.state.pagingCriteria}
          updatePagedResults={this.handlePagingCriteriaChange}
          getExportData={this.getExportData}
        ></PagedDatatable>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    workflowItemSteps: state.DataTranscribeQueue.workflowItemSteps,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
    loadingWorkflowSteps: state.DataTranscribeQueue.loadingWorkflowSteps,
    totalWorkflowItemSteps: state.DataTranscribeQueue.totalWorkflowItemSteps
  };
}

const mapDispatchToProps = {
  searchPaperReportsPaged,
  openReport,
  assignAndOpen,
  unAssign
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataTranscribeQueue);
